import gql from 'graphql-tag';
import { PureQueryOptions } from 'apollo-client';
import { AgFinancing, AgFinancingFileParamsInput, AgFinancingFilesContext } from '@indigo-ag/schema';

import { fileQueryFields } from './common.queries';

const documentRequestInfo = `
  id
  documentType
  associateWith
  notes
  dueDate
  status
  files {
    ${fileQueryFields}
  }
  events {
    id
    eventType
    text
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
`;

// * Requests Tab
export const getDocumentRequestsForFinancing = gql`
  query financingAgFinancingRequests($agFinancingId: ID!) {
    financingAgFinancingRequests(agFinancingId: $agFinancingId) {
      ${documentRequestInfo}
    }
  }
`;

export const createAgFinancingDocumentRequest = gql`
  mutation createAgFinancingRequest($data: AgFinancingRequestInput!) {
    createAgFinancingRequest(data: $data) {
      ${documentRequestInfo}
    }
  }
`;

export const updateAgFinancingRequestStatus = gql`
  mutation updateAgFinancingRequestStatus($requestId: String!, $status: AgFinancingRequestStatuses!) {
    updateAgFinancingRequestStatus (requestId: $requestId, status: $status) {
      ${documentRequestInfo}
    }
  }
`;

export const createAgFinancingRequestRevision = gql`
  mutation createAgFinancingRequestRevision($requestId: String!, $reason: String!) {
    createAgFinancingRequestRevision(requestId: $requestId, reason: $reason)
  }
`;

export const saveAgFinancingRequestFiles = gql`
  mutation saveAgFinancingRequestFiles($requestId: String!, $files: [AgFinancingFileInput]!) {
    saveAgFinancingRequestFiles(requestId: $requestId, files: $files)
  }
`;

// * Documents Tab
export const getFilesForFinancing = gql`
  query financingAgFinancingFiles($params: AgFinancingFileParamsInput!) {
    financingAgFinancingFiles (params: $params) {
      ${fileQueryFields}
    }
  }
`;

export const getDocumentsQueryByFinancingId = (
  agFinancingId: AgFinancing['id'],
  documentType?: AgFinancingFileParamsInput['documentType']
): PureQueryOptions => {
  return {
    query: getFilesForFinancing,
    variables: {
      params: {
        agFinancingId,
        context: [
          AgFinancingFilesContext.REQUEST,
          AgFinancingFilesContext.DOCUMENTS,
          AgFinancingFilesContext.PESQUISA_SERASA,
          AgFinancingFilesContext.CONTRACT_DRAFT_DOCUMENTS,
          AgFinancingFilesContext.SIGNED_CONTRACT_DOCUMENTS
        ],
        documentType
      }
    }
  };
};

export const createAgFinancingFile = gql`
  mutation createAgFinancingFile($data: [AgFinancingFileCreateInput]!) {
    createAgFinancingFile(data: $data) {
      ${fileQueryFields}
    }
  }
`;

export const updateAgFinancingFile = gql`
  mutation updateAgFinancingFile($data: [AgFinancingFileUpdateInput!]!) {
    updateAgFinancingFile(data: $data) {
      ${fileQueryFields}
    }
  }
`;
